import React, { useState } from 'react';
import styled from 'styled-components';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';

const DropdownContainer = styled.div`
  position: relative;
  width: 150px;
  @media (max-width: 768px) {
    width: 100px;
  }
  @media (max-width: 350px) {
    width: 85px;
  }
`;

const DropdownButton = styled.div`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    border-color: #aaa;
  }

  @media (max-width: 768px) {
    padding: 6px 10px;
    font-size: 14px;
  }

  @media (max-width: 480px) {
    padding: 5px 8px;
    font-size: 12px;
  }
`;

const DropdownList = styled.ul<{ $isOpen: boolean }>`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: ${({ $isOpen }) => ($isOpen ? '200px' : '0')};
  overflow-y: auto;
  padding: ${({ $isOpen }) => ($isOpen ? '10px 0' : '0')};
  margin: 0;
  border: ${({ $isOpen }) => ($isOpen ? '1px solid #ddd' : 'none')};
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  list-style: none;
  transition: all 0.3s ease;
  z-index: 1000;

  @media (max-width: 768px) {
    max-height: ${({ $isOpen }) => ($isOpen ? '150px' : '0')};
    font-size: 14px;
  }

  @media (max-width: 480px) {
    max-height: ${({ $isOpen }) => ($isOpen ? '120px' : '0')};
    font-size: 12px;
  }
`;

const DropdownItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }

  @media (max-width: 768px) {
    padding: 8px 12px;
  }

  @media (max-width: 480px) {
    padding: 6px 10px;
  }
`;

interface Option {
  key: string;
  value: string; // 실제 데이터 값
  label: string; // 드롭다운에 표시할 값
}

interface DropdownProps {
  options: Option[];
  selected: string;
  onSelect: (value: string) => void;
  placeholder?: string; // 기본 텍스트를 위한 새로운 prop 추가
}

const CustomDropdown: React.FC<DropdownProps> = ({
  options,
  selected,
  onSelect,
  placeholder = 'Select an option', // 기본값 설정
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSelect = (value: string) => {
    onSelect(value);
    setIsOpen(false);
  };

  // 선택된 옵션의 라벨을 찾거나, 기본값(placeholder) 표시
  const selectedOptionLabel =
    options.find((option) => option.key === selected)?.label || placeholder;

  return (
    <DropdownContainer>
      <DropdownButton onClick={toggleDropdown}>
        {selectedOptionLabel}
        {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
      </DropdownButton>
      <DropdownList $isOpen={isOpen}>
        {options.map((option) => (
          <DropdownItem
            key={option.key}
            onClick={() => handleSelect(option.key)}
          >
            {option.label}
          </DropdownItem>
        ))}
      </DropdownList>
    </DropdownContainer>
  );
};

export default CustomDropdown;
